export default "/images/vendor/flag-icon-css/flags/4x3/mv.svg?0329f53cf8f786716fe4c85fecf33bf2";